// extracted by mini-css-extract-plugin
export var questionBox = "_90-0";